"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const Chip_1 = __importDefault(require("@mui/material/Chip"));
const transactions_1 = require("companion-app-components/flux/transactions");
const utils_1 = require("data/transactions/utils");
const RegCategoryField_1 = __importDefault(require("./RegCategoryField"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const CategoryField = ({ attributes, forceStatic, callbacks, editable, SHOW_ALL, txn, wrapClass, editClass, hoverClass, bankPendingClass, currEditFieldName, wrapperId, longCats, wrapText, showSplitWindow, focusField, }) => {
    const { classes } = useStyles();
    const c2RTxnClass = (0, utils_1.isC2RTransaction)(txn) ? classes.txnInC2RText : '';
    return (<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)(classes.regItem, 'flex2', wrapClass, editClass, hoverClass, bankPendingClass, c2RTxnClass, (transactions_1.transactionsUtils.isSplitTxn(txn) && editable) ? classes.withClearSplits : null)} onClick={(!txn.split && forceStatic) ? null : () => { var _a; return (_a = callbacks.regFieldClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'category', txn); }}>
      {SHOW_ALL &&
            <RegCategoryField_1.default txn={txn} editable={editable && currEditFieldName === 'category'} 
            // @ts-expect-error: The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & AmountFieldProps'
            onChange={callbacks.handleChange} forceStatic={forceStatic} longCats={longCats} 
            // @ts-expect-error: Type 'string' is not assignable to type 'boolean'.
            wrapText={wrapText} showSplitWindow={showSplitWindow} context={wrapperId} inputRef={editable && !forceStatic && currEditFieldName === 'category' ?
                    (input) => {
                        focusField.current = input; // eslint-disable-line
                    } : null}/>}
      {transactions_1.transactionsUtils.isSplitTxn(txn) && editable &&
            <Chip_1.default label="Clear Splits" size="small" onClick={(e) => {
                    var _a;
                    e.stopPropagation();
                    (_a = callbacks.regFieldClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'clearSplits', txn);
                }} className={classes.clearSplits}/>}
    </styles_1.RegListItem>);
};
exports.default = CategoryField;
